// extracted by mini-css-extract-plugin
export default {"form":"signup-form_form__0SDjw"};